var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercardLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 24,
    fill: "none",
    viewBox: "0 0 39 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5f00",
    d: "M25.19 2.566H13.64v18.867h11.55z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eb001b",
    d: "M14.83 12a11.98 11.98 0 0 1 4.582-9.432 11.998 11.998 0 1 0 0 18.867A11.98 11.98 0 0 1 14.829 12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f79e1b",
    d: "M37.679 19.437v-.386h.166v-.08h-.396v.08h.156v.386zm.77 0v-.466h-.12l-.14.333-.14-.333h-.12v.466h.086v-.353l.13.303h.09l.13-.303v.353zm.376-7.436a11.999 11.999 0 0 1-19.413 9.432 12 12 0 0 0 0-18.867 11.998 11.998 0 0 1 19.413 9.432z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardLogo);
export default __webpack_public_path__ + "static/media/mastercard_logo.7ce17a2e653d0c03a86239824dc3b418.svg";
export { ForwardRef as ReactComponent };